// import React, { useEffect, useState } from "react";
// import styles from "./Login.module.scss";
// import { showErrorToast, showSuccessToast } from "../../../assets/toastUtils";
// import { getDecryptedData, saveEncryptedData } from "../../../utils/crypto";
// import { useLocation, useNavigate } from "react-router-dom";

// const CustomerLogin = ({ isOpen, toggleSlider, setIsOpen }) => {
//   const navigate = useNavigate();
//   const [openPopup, setOpenPopup] = useState(false);
//   const [openResetPopup, setOpenResetPopup] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [openRegisterPopup, setOpenRegisterPopup] = useState(false);
//   const location = useLocation();
//   const queryParams = new URLSearchParams(location.search);
//   const initialRole = queryParams.get("role") || "customer";
//   const [activeForm, setActiveForm] = useState(initialRole);
//   const [isCreatingAccount, setIsCreatingAccount] = useState(false);
//   const [resetForm, setResetForm] = useState(false);
//   const [formErrors, setFormErrors] = useState({});
//   const [loading, setLoading] = useState(false);

//   const validate = () => {
//     const errors = {};
//     if (!formData?.email.trim()) {
//       errors.email = "required";
//     }
//     if (!formData?.password.trim()) {
//       errors.password = "required";
//     }

//     setFormErrors(errors);

//     if (Object.keys(errors).length === 0) {
//       return true;
//     } else {
//       return false;
//     }

//     return Object.keys(errors).length === 0;
//   };

//   const [formData, setFormData] = useState({
//     name: "",
//     phone: "",
//     email: "",
//     password: "",
//     confirmPassword: "",
//   });

//   useEffect(() => {
//     const role = queryParams.get("role") || "customer";
//     setActiveForm(role);
//   }, [location.search]);

//   const switchForm = (form) => {
//     setFormData({
//       name: "",
//       phone: "",
//       email: "",
//       password: "",
//       confirmPassword: "",
//     });
//     setActiveForm(form);
//     setIsCreatingAccount(false);
//     setResetForm(false);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const userToken = localStorage.getItem("token");
//   // console.log(userToken, "tokkkk");
//   const [agentDetails, setAgentData] = useState();

//   const fetchAgentDetails = (token) => {
//     // console.log("agent");
//     fetch(
//       `${process.env.REACT_APP_BASE_URL}/api/v1/website/agent/user-profile`,
//       {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     )
//       .then((response) => response.json())
//       .then((data) => {
//         setAgentData(data.data);

//         if (data.success) {
//           if (data.data.accountStatus === "disable") {
//             navigate("/agent-account");
//           } else {
//             navigate("/");
//           }
//           localStorage.setItem("userDetails", JSON.stringify(data.data.agent));
//         } else {
//         }
//       })
//       .catch((error) => {
//         // Handle fetch errors
//         console.error("Error fetching agent details:", error);
//       });
//   };

//   const fetchCustomerDetails2 = (token) => {
//     fetch(`${process.env.REACT_APP_APP_URL}/api/v1/customers/user-profile`, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         // console.log(data.data.agent, "test");
//         setAgentData(data.data.agent);

//         if (data.success) {
//           // if (data.data.agent.AccountStatus === "disable") {
//           //     navigate("/agent-account");
//           // } else {
//           // }
//           localStorage.setItem(
//             "userDetails",
//             JSON.stringify(data.data.customer)
//           );
//           navigate("/customer-dashboard");
//         } else {
//         }
//       })
//       .catch((error) => {
//         // Handle fetch errors
//         console.error("Error fetching agent details:", error);
//       });
//   };

//   const fetchCustomerDetails = async (token) => {
//     const myHeaders = new Headers();
//     myHeaders.append("Accept", "application/json");
//     myHeaders.append("Authorization", `Bearer ${token}`);
//     const cookie = process.env.REACT_APP_COOKIE || "";
//     myHeaders.append("Cookie", cookie);

//     const requestOptions = {
//       method: "GET",
//       headers: myHeaders,
//       redirect: "follow",
//     };

//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_BASE_URL}/api/v1/website/customer/user-profile`,
//         requestOptions
//       );
//       const result = await response.json();
//       if (result.success) {
//         localStorage.setItem("userDetails", JSON.stringify(result.data));
//         navigate("/customer-dashboard");
//       } else {
//         showErrorToast(
//           result.message || "User Profile not fetched successfully.."
//         );
//       }
//     } catch (error) {
//       console.error("Error fetching customer details:", error);
//     }
//   };

//   const handleCustomerSubmit = async (event) => {
//     event.preventDefault();
//     const valid = validate();
//     setTimeout(() => {
//       setFormErrors({});
//     }, 1500);
//     if (!valid) {
//       showErrorToast("Please fill the required details");
//       return;
//     }

//     if (isCreatingAccount && formData.password !== formData.confirmPassword) {
//       showErrorToast("Passwords do not match.");
//       return;
//     }

//     const myHeaders = new Headers();
//     myHeaders.append("Accept", "application/json");
//     myHeaders.append(
//       "Authorization",
//       "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI5YzZhOGFjMi1mMzY2LTQ3NWMtYTVhZi1iMDNiMDRhZDY1ZWMiLCJqdGkiOiI1NDM5YmM0NTA4ODIyZTgyMzZjYmNhN2NlODdjZjk0NjBlMjY3ZWE0ZWNkNTQzYTAyMjFlNDE0NmE1NTc1ZjA4ZTkyYWE0NmM2YTc1ZjBlYSIsImlhdCI6MTcxOTgxNTI2NC43NDcxNDMsIm5iZiI6MTcxOTgxNTI2NC43NDcxNTEsImV4cCI6MTc1MTM1MTI2NC43MzQxNTcsInN1YiI6IjEiLCJzY29wZXMiOltdfQ.d5Vk5mqWxr1CMXrV45qHvwLWygjTqf9HsV-jt2XOD_iIdWehrRCLOVaCewHGWTs493UkI8TlAeL_3g2zci-JSUVsfN2GnU-HxuTwWdNRdIf2E64d1GXH3olWVUEuyPpdaWSyqYGRT33zi9Z2blrY1hFULrGNWe2P1c5ksntTbmn5U8XDX3KIGTBkmhy9U0G3hMPfSIPIi96bdKIVi1LMKOTu6y3p6Pxk9k5doMX82qRlMyAQV8_hLs3P8MGTijL3j3Drqub_NhhTx5xafg3KuKeFHrmQUqF2Ddtx9fLHB-EEch_LnEG3ZVtD2ThObXrKcBxgwgQesa5GHNpFP555JElBfw3Cgk-rIHVWflFzUZsaK7FmD3EH_qkg91OR0TUy0snvD_FqhEPDDbuLwW78JWhqPhjz8X8q1FsgtonN4uYB2gZa1tHWMopWm8TItaK9EO1TNM-CHsQPFS-hiBT8Ul6bcngIiY-HPGH6GXz6oWI896K9KPHUjW1JSNI2sA5Jyg9I7Gt5ccDhyuGLYtxvPPujfKDctbeQbMQomBMHWxSfwpvYHMQ3tqlpTrkdYL6HGBa5mTto6-glwQ06TXYCZPsYvquAzXg43jiS1Uu7gqYMcQT57oLhfpFCmC5KV3KiX90eISuId6_z0awIb7ZfCjXmEvtKzK9RZbOIepeo9Gc"
//     );

//     const formdata = new FormData();
//     if (isCreatingAccount) {
//       formdata.append("name", formData.name);
//       formdata.append("email", formData.email);
//       formdata.append("password", formData.password);
//       formdata.append("c_password", formData.confirmPassword);
//       formdata.append("account_id", "1");

//       const requestOptions = {
//         method: "POST",
//         headers: myHeaders,
//         body: formdata,
//         redirect: "follow",
//       };

//       try {
//         const response = await fetch(
//           `${process.env.REACT_APP_APP_URL}/api/v1/customers/sign-up`,
//           requestOptions
//         );

//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }

//         const result = await response.json();
//         // console.log("Customer Registration API response:", result);

//         if (result) {
//           showSuccessToast(result.data.message || "Registration Successful");
//           localStorage.setItem("customerData", JSON.stringify(formData));
//           setIsCreatingAccount(false);
//         }
//       } catch (error) {
//         console.error("Error fetching data:", error.message);
//         showErrorToast("Check Credentials");
//       }
//     } else {
//       formdata.append("email", formData.email);
//       formdata.append("password", formData.password);

//       const requestOptions = {
//         method: "POST",
//         body: formdata,
//         redirect: "follow",
//       };

//       try {
//         const response = await fetch(
//           `${process.env.REACT_APP_APP_URL}/api/v1/customers/login`,
//           requestOptions
//         );

//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }

//         const result = await response.json();
//         // console.log("Customer Login API response:", result);

//         if (result) {
//           // alert("test")
//           // Save token to localStorage after successful login
//           localStorage.setItem("token", result.data.token);
//           localStorage.setItem("userType", "customer");
//           // Navigate to the homepage
//           showSuccessToast(result.data.message || "Login Successful");
//           localStorage.setItem("customerData", JSON.stringify(formData));
//           fetchCustomerDetails(result.data.token);
//           // navigate("/customer-dashboard");
//         }
//       } catch (error) {
//         console.error("Error fetching data:", error.message);
//         showErrorToast("Unauthorized access");
//       }
//     }
//   };

//   const registerCustomer = async (e) => {
//     e.preventDefault();
//     const myHeaders = new Headers();
//     myHeaders.append("Accept", "application/json");
//     myHeaders.append("Content-Type", "application/json");
//     myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
//     myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

//     const raw = JSON.stringify({
//       type: "customer",
//       name: formData?.name,
//       email: formData?.email,
//       callbackUrl: "https://mountainmysteries.com",
//     });

//     const requestOptions = {
//       method: "POST",
//       headers: myHeaders,
//       body: raw,
//       redirect: "follow",
//     };

//     try {
//       setLoading(true);
//       const response = await fetch(
//         `${process.env.REACT_APP_BASE_URL}/api/v1/website/accounts/register`,
//         requestOptions
//       );
//       const result = await response.json();
//       if (result.success) {
//         showSuccessToast(result.message);
//         setFormData({
//           name: "",
//           email: "",
//         });
//       } else {
//         showErrorToast(result.message);
//       }
//     } catch (error) {
//       showErrorToast("Error registering Customer");
//       console.error("Error registering user:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loginCustomer = async (e) => {
//     e.preventDefault();
//     const valid = validate();
//     setTimeout(() => {
//       setFormErrors({});
//     }, 1500);
//     if (!valid) {
//       showErrorToast("Please fill the above details.");
//       return;
//     }
//     const myHeaders = new Headers();
//     myHeaders.append("Accept", "application/json");
//     myHeaders.append("Content-Type", "application/json");
//     myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
//     myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

//     const raw = JSON.stringify({
//       type: "customer",
//       email: formData?.email,
//       password: formData?.password,
//     });

//     const requestOptions = {
//       method: "POST",
//       headers: myHeaders,
//       body: raw,
//       redirect: "follow",
//     };

//     try {
//       setLoading(true);
//       const response = await fetch(
//         `${process.env.REACT_APP_BASE_URL}/api/v1/website/accounts/login`,
//         requestOptions
//       );
//       const result = await response.json();

//       if (result?.success) {
//         showSuccessToast(result.message || "Login Successful");
//         localStorage.setItem("token", result.data.token);
//         saveEncryptedData("userToken", result.data.token);
//         localStorage.setItem("userType", "customer");
//         localStorage.setItem("customerData", JSON.stringify(result.data));
//         fetchCustomerDetails(result.data.token);
//       } else {
//         showErrorToast(result.message || "Login Failed");
//       }
//     } catch (error) {
//       showErrorToast("Login Failed");
//       console.error("Error Login customer:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleconfirmpasss = async (event) => {
//     event.preventDefault();
//   };

//   const handleAgentSubmit = async (event) => {
//     event.preventDefault();

//     if (isCreatingAccount && formData.password !== formData.confirmPassword) {
//       showErrorToast("Passwords do not match.");
//       return;
//     }

//     const myHeaders = new Headers();
//     myHeaders.append("Accept", "application/json");
//     myHeaders.append(
//       "Authorization",
//       "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI5YzZhZTMyZS01N2U1LTRiNTktYTNiZS1lN2I1NTU5NTUyNTQiLCJqdGkiOiI5OGQ3MDk5MjRlYjkxZWYwYWYwMWRiOWRjMzRiMDdmYjk0MmFhZjBhNTkxMGRlMTE5OWY2MzUyMDE1NzBkZDg5ODRiMTI3YTE2YzI3YTZkOCIsImlhdCI6MTcyMDQ0MDQ5Ny41ODg1ODIsIm5iZiI6MTcyMDQ0MDQ5Ny41ODg1ODgsImV4cCI6MTc1MTk3NjQ5Ny41Njg5NTYsInN1YiI6IjEiLCJzY29wZXMiOltdfQ.yUfgInQFlDZPGpK8oAy5W8IG1KYZyRjBiB8G2Kz2I9doQBxJvxCiJR4HQ1HlBhx8-R9EL1EzvJzAOfhhe3Sxoz0YIJEhrXUTx_6kHuk5xIt2Ky1G6XCP_M3jPVf7y4yv8fJBPEgPILGOSKVPQI9kizWu_vozz4_hkg3-1oMDEYTUiDyt-YlyM688ckprCp7ScSL8irSKxLDcv5su4ssa_T2Ln7WpDVEcTa2O0Sa41IepEhQg8jGpja10QbPlU2vM2zreYcxsmSELzZgFCAbJqVc9oNnYIi-qY19baj3mmze-8hB796gLyysnBWrPflXUjXl9fC_ojK33Mx-MOH_62txvyAV3NjKFiCq6Hn9-68f4gi_TN67H7yUf9ZiX7SoH6WtiwKfIP2_rhnyt3Fj8xZGGisAE9POn6VrwoIoz5kXYGFfhpwYNkw3CZ1M8XWw3yq-DvQveAusONPLrKhkdmJXVBZKwCYq7dARUfqBgfT_TOOzCTTblwI4UFgdYhF8ihLcdkg-vmSRK5IT-c_pHolbDx8TGvbRZ1vyebltu7xKkHN4NbksCxRRYfMAFhm8geFGTdfSlMx0v4-6VDPDW1zAe1_6tsYhvyDbgUuVTdR9UVhSY5XOFnNsVZ3ph5VvYvIs3hjACWKeKiXUWHwgDa0pm4FBsdy1knZRCbmNanmE"
//     );

//     const formdata = new FormData();
//     if (isCreatingAccount) {
//       formdata.append("name", formData.name);
//       formdata.append("email", formData.email);
//       formdata.append("password", formData.password);
//       formdata.append("c_password", formData.confirmPassword);
//       formdata.append("account_id", "1");

//       const requestOptions = {
//         method: "POST",
//         headers: myHeaders,
//         body: formdata,
//         redirect: "follow",
//       };

//       try {
//         const response = await fetch(
//           `${process.env.REACT_APP_APP_URL}/api/v1/agents/sign-up`,
//           requestOptions
//         );

//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }

//         const result = await response.json();
//         // console.log("Agent Registration API response:", result);

//         // Save token to localStorage after successful registration
//         localStorage.setItem("token", result.data.token);

//         if (result) {
//           showSuccessToast(result.data.message || "Registration Successful");
//           setIsCreatingAccount(false);
//           localStorage.setItem("agentData", JSON.stringify(formData));
//         }

//         // Handle API response as needed
//       } catch (error) {
//         showErrorToast("Something went wrong", error.message);
//       }
//     } else {
//       formdata.append("email", formData.email);
//       formdata.append("password", formData.password);

//       const requestOptions = {
//         method: "POST",
//         headers: myHeaders,
//         body: formdata,
//         redirect: "follow",
//       };

//       try {
//         const response = await fetch(
//           `${process.env.REACT_APP_APP_URL}/api/v1/agents/login`,
//           requestOptions
//         );

//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }

//         const result = await response.json();

//         if (result?.success) {
//           // console.log("Agent Login API response:", result.data.token);

//           // Save token to localStorage after successful login
//           localStorage.setItem("token", result.data.token);
//           localStorage.setItem("agentData", JSON.stringify(formData));
//           localStorage.setItem("userType", "agent");
//           fetchAgentDetails(result.data.token);

//           showSuccessToast("Login Successful");
//         } else {
//           showErrorToast(result.data.message || "Login Failed");
//         }
//       } catch (error) {
//         console.error("Error fetching data:", error.message);
//         showErrorToast("Unauthorized access");
//       }
//     }
//   };

//   const handleResetPasswordAgent = async (event) => {
//     event.preventDefault(); // Prevent the default form submission

//     const email = formData.email; // Assuming there's an input field with ID 'email'

//     const requestOptions = {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ email: email }),
//       redirect: "follow",
//     };

//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_APP_URL}/api/agent/send-reset-link`,
//         requestOptions
//       );
//       if (!response.ok) {
//         throw new Error(`Error: ${response.statusText}`);
//       }
//       const result = await response.json();
//       // console.log(result);
//       showSuccessToast("Password reset link has been sent to your email.");
//     } catch (error) {
//       console.error(error);
//       showErrorToast(
//         "An error occurred while trying to reset the password. Please try again."
//       );
//     }
//   };

//   const [resetEmail, setResetEmail] = useState("");

//   const handleResetPasswordCustomer = async (event) => {
//     event.preventDefault();

//     // if (formData.password !== formData.confirmPassword) {
//     //   showErrorToast("Passwords do not match.");
//     //   return;
//     // }

//     const myHeaders = new Headers();
//     myHeaders.append("Content-Type", "application/json");
//     myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);

//     const raw = JSON.stringify({
//       email: resetEmail,
//       type: "customer",
//       callbackUrl: "https://www.mountainmysteries.com/reset-password/customer",
//     });

//     const requestOptions = {
//       method: "POST",
//       headers: myHeaders,
//       body: raw,
//       redirect: "follow",
//     };

//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_BASE_URL}/api/v1/website/accounts/send-password-reset-link`,
//         requestOptions
//       );

//       const result = await response.json();
//       if (result.success) {
//         showSuccessToast(result.message || "Please Check Your Email.");
//       } else {
//         showErrorToast(result.message || "Password Reset Failed");
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error.message);
//       showErrorToast("Password Reset Failed");
//     }
//   };

//   return (
//     <>
//       {isOpen && (
//         <div
//           className={`${styles.login_popup_overlay} ${
//             isOpen ? styles.open : styles.close
//           }`}
//         >
//           <div
//             className={`${styles.login_slider} ${
//               isOpen ? styles.open : styles.close
//             }`}
//           >
//             <div className={styles.login_details}>
//               <svg
//                 onClick={toggleSlider}
//                 width="20"
//                 height="20"
//                 viewBox="0 0 20 20"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path
//                   d="M1.12203 20L0 18.878L8.87797 10L0 1.12203L1.12203 0L10 8.87797L18.878 0L20 1.12203L11.122 10L20 18.878L18.878 20L10 11.122L1.12203 20Z"
//                   fill="#1C1B1F"
//                 />
//               </svg>
//               <h2>Log In</h2>
//               <form onSubmit={loginCustomer}>
//                 <div>
//                   <label>Email</label>
//                   <input
//                     style={
//                       formErrors.email && {
//                         background: "#ff000040",
//                         borderBottom: "1px solid red",
//                       }
//                     }
//                     name="email"
//                     value={formData?.email}
//                     onChange={handleInputChange}
//                     type="email"
//                     placeholder="Enter email address"
//                   />
//                 </div>
//                 <div className="relative">
//                   <label>Password</label>
//                   <input
//                     placeholder="Enter password"
//                     style={
//                       formErrors.password && {
//                         background: "#ff000040",
//                         borderBottom: "1px solid red",
//                       }
//                     }
//                     name="password"
//                     value={formData?.password}
//                     onChange={handleInputChange}
//                     type={showPassword ? "text" : "password"}
//                   />
//                   {showPassword ? (
//                     <svg
//                       onClick={() => setShowPassword(false)}
//                       style={{
//                         position: "absolute",
//                         top: "34px",
//                         right: "5px",
//                         cursor: "pointer",
//                       }}
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="16"
//                       height="16"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                     >
//                       <path
//                         d="M2 2L22 22"
//                         stroke="#888888"
//                         strokeWidth="2"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       />
//                       <path
//                         d="M6.71277 6.7226C3.66479 8.79527 2 12 2 12C2 12 5.63636 19 12 19C14.0503 19 15.8174 18.2734 17.2711 17.2884M11 5.05822C11.3254 5.02013 11.6588 5 12 5C18.3636 5 22 12 22 12C22 12 21.3082 13.3317 20 14.8335"
//                         stroke="#888888"
//                         strokeWidth="2"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       />
//                       <path
//                         d="M14 14.2362C13.4692 14.7112 12.7684 15.0001 12 15.0001C10.3431 15.0001 9 13.657 9 12.0001C9 11.1764 9.33193 10.4303 9.86932 9.88818"
//                         stroke="#888888"
//                         strokeWidth="2"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       />
//                     </svg>
//                   ) : (
//                     <svg
//                       onClick={() => setShowPassword(true)}
//                       style={{
//                         position: "absolute",
//                         top: "33px",
//                         right: "5px",
//                         cursor: "pointer",
//                       }}
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="16"
//                       height="16"
//                       viewBox="0 0 14 10"
//                       fill="none"
//                     >
//                       <g clipPath="url(#clip0_1_298)">
//                         <path
//                           d="M7.00001 3.25C6.53588 3.25 6.09076 3.43437 5.76257 3.76256C5.43438 4.09075 5.25001 4.53587 5.25001 5C5.25001 5.46413 5.43438 5.90925 5.76257 6.23744C6.09076 6.56563 6.53588 6.75 7.00001 6.75C7.46414 6.75 7.90926 6.56563 8.23745 6.23744C8.56564 5.90925 8.75001 5.46413 8.75001 5C8.75001 4.53587 8.56564 4.09075 8.23745 3.76256C7.90926 3.43437 7.46414 3.25 7.00001 3.25ZM7.00001 7.91667C6.22646 7.91667 5.4846 7.60938 4.93762 7.06239C4.39063 6.51541 4.08334 5.77355 4.08334 5C4.08334 4.22645 4.39063 3.48459 4.93762 2.93761C5.4846 2.39062 6.22646 2.08333 7.00001 2.08333C7.77356 2.08333 8.51542 2.39062 9.0624 2.93761C9.60939 3.48459 9.91668 4.22645 9.91668 5C9.91668 5.77355 9.60939 6.51541 9.0624 7.06239C8.51542 7.60938 7.77356 7.91667 7.00001 7.91667ZM7.00001 0.625C4.08334 0.625 1.59251 2.43917 0.583344 5C1.59251 7.56083 4.08334 9.375 7.00001 9.375C9.91668 9.375 12.4075 7.56083 13.4167 5C12.4075 2.43917 9.91668 0.625 7.00001 0.625Z"
//                           fill="#888888"
//                         ></path>
//                       </g>
//                       <defs>
//                         <clipPath id="clip0_1_298">
//                           <rect width="14" height="10" fill="white"></rect>
//                         </clipPath>
//                       </defs>
//                     </svg>
//                   )}
//                 </div>
//                 <button className={styles.login_btn_new} type="submit">
//                   Log In{" "}
//                   <svg
//                     width="17"
//                     height="17"
//                     viewBox="0 0 15 15"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <mask
//                       id="mask0_6831_12431"
//                       style={{ maskType: "alpha" }}
//                       maskUnits="userSpaceOnUse"
//                       x="0"
//                       y="0"
//                       width="17"
//                       height="17"
//                     >
//                       <rect width="15" height="15" fill="#D9D9D9" />
//                     </mask>
//                     <g mask="url(#mask0_6831_12431)">
//                       <path
//                         d="M10.3919 7.96839H3.28125C3.14823 7.96839 3.03687 7.92349 2.94719 7.8337C2.8574 7.74401 2.8125 7.63266 2.8125 7.49964C2.8125 7.36662 2.8574 7.25526 2.94719 7.16558C3.03687 7.07578 3.14823 7.03089 3.28125 7.03089H10.3919L7.16109 3.80011C7.06818 3.70719 7.02229 3.59844 7.02344 3.47386C7.02469 3.34927 7.07375 3.23849 7.17063 3.14151C7.2676 3.05099 7.3774 3.00412 7.5 3.00089C7.6226 2.99766 7.7324 3.04453 7.82938 3.14151L11.792 7.10417C11.8506 7.16271 11.8918 7.22443 11.9158 7.28933C11.9398 7.35422 11.9519 7.42433 11.9519 7.49964C11.9519 7.57495 11.9398 7.64505 11.9158 7.70995C11.8918 7.77485 11.8506 7.83657 11.792 7.89511L7.82938 11.8578C7.74281 11.9443 7.63563 11.9886 7.50781 11.9906C7.38 11.9926 7.2676 11.9483 7.17063 11.8578C7.07375 11.7608 7.02531 11.6494 7.02531 11.5237C7.02531 11.3979 7.07375 11.2865 7.17063 11.1895L10.3919 7.96839Z"
//                         fill="white"
//                       />
//                     </g>
//                   </svg>
//                 </button>
//               </form>{" "}
//               <p>
//                 Forgot your password?{" "}
//                 <span onClick={() => setOpenResetPopup(true)}>Reset Here</span>
//               </p>
//             </div>
//             <div className={styles.align_end}>
//               <p>
//                 Don’t have an account?{" "}
//                 <span
//                   onClick={() => {
//                     setOpenRegisterPopup(true);
//                     // setIsOpen(false);
//                   }}
//                 >
//                   <u>REGISTER HERE</u>
//                 </span>
//               </p>
//             </div>
//           </div>
//         </div>
//       )}
//       {openResetPopup && (
//         <div className="popup_backdrop">
//           <div className="popup_section">
//             <form onSubmit={handleResetPasswordCustomer}>
//               {/* <form onSubmit={}> */}
//               <div className="flex justify_content_between align_items_center">
//                 <h4 className="text-left">
//                   <b>Reset Your Password</b>
//                 </h4>
//                 <svg
//                   onClick={() => setOpenResetPopup(false)}
//                   width="14"
//                   height="13"
//                   viewBox="0 0 14 13"
//                   fill="none"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <path d="M1 12.5L13 0.5" stroke="#AAAAAA" strokeWidth="1.2" />
//                   <path d="M13 12.5L1 0.5" stroke="#AAAAAA" strokeWidth="1.2" />
//                 </svg>
//               </div>
//               <div className="LoginVendor_form_cont mt-10">
//                 <label htmlFor="">Email</label>
//                 <input
//                   name="email"
//                   value={formData?.email}
//                   onChange={(e) => setResetEmail(e.target.value)}
//                   type="email"
//                   required
//                 />
//               </div>
//               <button
//                 type="submit"
//                 className="LoginVendor_form_submit red_new_btn_black"
//                 // onClick={resetPasswordHandler}
//               >
//                 Send{" "}
//               </button>
//             </form>
//           </div>
//         </div>
//       )}

//       {openRegisterPopup && (
//         <div
//           className={`${styles.login_popup_overlay_register} ${
//             isOpen ? styles.open : styles.close
//           }`}
//         >
//           <div
//             className={`${styles.login_slider_register} ${
//               isOpen ? styles.open : styles.close
//             }`}
//           >
//             <div className={styles.login_details}>
//               <svg
//                 onClick={toggleSlider}
//                 width="20"
//                 height="20"
//                 viewBox="0 0 20 20"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path
//                   d="M1.12203 20L0 18.878L8.87797 10L0 1.12203L1.12203 0L10 8.87797L18.878 0L20 1.12203L11.122 10L20 18.878L18.878 20L10 11.122L1.12203 20Z"
//                   fill="#1C1B1F"
//                 />
//               </svg>
//               <h2>Its Free, Register Now</h2>
//               <form onSubmit={registerCustomer} action="">
//                 <div>
//                   <label>FULL NAME</label>
//                   <input
//                     style={
//                       formErrors.name && {
//                         backgroundColor: "#ff000040",
//                         borderBottom: "1px solid red",
//                       }
//                     }
//                     className="w-full"
//                     value={formData.name}
//                     onChange={handleInputChange}
//                     name="name"
//                     type="text"
//                     placeholder="Enter full name"
//                   />
//                 </div>
//                 <div>
//                   <label>EMAIL ADDRESS</label>
//                   <input
//                     style={
//                       formErrors.email && {
//                         backgroundColor: "#ff000040",
//                         borderBottom: "1px solid red",
//                       }
//                     }
//                     className="w-100"
//                     value={formData.email}
//                     onChange={handleInputChange}
//                     name="email"
//                     placeholder="Enter email address"
//                   />
//                 </div>
//                 <button className={styles.login_btn} type="submit">
//                   Register{" "}
//                   <svg
//                     width="17"
//                     height="17"
//                     viewBox="0 0 15 15"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <mask
//                       id="mask0_6831_12431"
//                       style={{ maskType: "alpha" }}
//                       maskUnits="userSpaceOnUse"
//                       x="0"
//                       y="0"
//                       width="17"
//                       height="17"
//                     >
//                       <rect width="15" height="15" fill="#D9D9D9" />
//                     </mask>
//                     <g mask="url(#mask0_6831_12431)">
//                       <path
//                         d="M10.3919 7.96839H3.28125C3.14823 7.96839 3.03687 7.92349 2.94719 7.8337C2.8574 7.74401 2.8125 7.63266 2.8125 7.49964C2.8125 7.36662 2.8574 7.25526 2.94719 7.16558C3.03687 7.07578 3.14823 7.03089 3.28125 7.03089H10.3919L7.16109 3.80011C7.06818 3.70719 7.02229 3.59844 7.02344 3.47386C7.02469 3.34927 7.07375 3.23849 7.17063 3.14151C7.2676 3.05099 7.3774 3.00412 7.5 3.00089C7.6226 2.99766 7.7324 3.04453 7.82938 3.14151L11.792 7.10417C11.8506 7.16271 11.8918 7.22443 11.9158 7.28933C11.9398 7.35422 11.9519 7.42433 11.9519 7.49964C11.9519 7.57495 11.9398 7.64505 11.9158 7.70995C11.8918 7.77485 11.8506 7.83657 11.792 7.89511L7.82938 11.8578C7.74281 11.9443 7.63563 11.9886 7.50781 11.9906C7.38 11.9926 7.2676 11.9483 7.17063 11.8578C7.07375 11.7608 7.02531 11.6494 7.02531 11.5237C7.02531 11.3979 7.07375 11.2865 7.17063 11.1895L10.3919 7.96839Z"
//                         fill="white"
//                       />
//                     </g>
//                   </svg>
//                 </button>
//               </form>{" "}
//             </div>
//             <div className={styles.align_end}>
//               <p>
//                 Do you have an account?{" "}
//                 <span
//                   onClick={() => {
//                     setOpenRegisterPopup(false);
//                     setIsOpen(true);
//                   }}
//                 >
//                   <u>Log in </u>
//                 </span>
//               </p>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default CustomerLogin;

import React, { useState } from "react";
import styles from "./CustomerLogin.module.scss";
import { showErrorToast, showSuccessToast } from "../../../assets/toastUtils";
import { saveEncryptedData } from "../../../utils/crypto";
import { useNavigate } from "react-router-dom";

function CustomerLogin({ isOpen, toggleSlider, setIsOpen }) {
  const [showPopUp, setShowPopUp] = useState(false);
  const [isLogin, setIsLogin] = useState(true);
  const [reset, setReset] = useState(false);
  const [signUp, setSignUp] = useState(false);
  const [resetSuccess, setResetSuccess] = useState(false);
  const [logInSuccess, setLogInSuccess] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const handleToggleForm = () => {
    setIsLogin(!isLogin);
  };

  const [loginErrors, setLoginErrors] = useState({});
  const [signupErrors, setSignupErrors] = useState({});
  const [formType, setFormType] = useState("login");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleFormChangeData = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));

    if (formType === "login") {
      setLoginErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    } else {
      setSignupErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
  };

  const validateLogin = () => {
    const errors = {};
    const email = formData?.email?.trim() || "";
    const password = formData?.password?.trim() || "";
  
    if (!email) {
      errors.email = "required";
    }
    if (!password) {
      errors.password = "required";
    }
  
    setLoginErrors(errors);
    return Object.keys(errors).length === 0;
  };
  
  const validateSignup = () => {
    const errors = {};
    const name = formData?.name?.trim() || "";
    const email = formData?.email?.trim() || "";
  
    if (!name) {
      errors.name = "required";
    }
    if (!email) {
      errors.email = "required";
    }
  
    setSignupErrors(errors);
    return Object.keys(errors).length === 0;
  };
  

  const fetchCustomerDetails = async (token) => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);
    const cookie = process.env.REACT_APP_COOKIE || "";
    myHeaders.append("Cookie", cookie);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/customer/user-profile`,
        requestOptions
      );
      const result = await response.json();
      if (result.success) {
        localStorage.setItem("userDetails", JSON.stringify(result.data));
        // navigate("/customer-dashboard");
        setLogInSuccess(true);
      } else {
        showErrorToast(
          result.message || "User Profile not fetched successfully.."
        );
      }
    } catch (error) {
      console.error("Error fetching customer details:", error);
    }
  };
  const loginCustomer = async (e) => {
    e.preventDefault();
    const valid = validateLogin();

    if (!valid) {
      showErrorToast("Please fill the above details.");
      return;
    }
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const raw = JSON.stringify({
      type: "customer",
      email: formData?.email,
      password: formData?.password,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/accounts/login`,
        requestOptions
      );
      const result = await response.json();

      if (result?.success) {
        showSuccessToast(result.message || "Login Successful");
        localStorage.setItem("token", result.data.token);
        saveEncryptedData("userToken", result.data.token);
        localStorage.setItem("userType", "customer");
        localStorage.setItem("customerData", JSON.stringify(result.data));
        fetchCustomerDetails(result.data.token);
      } else {
        showErrorToast(result.message || "Login Failed");
      }
    } catch (error) {
      showErrorToast("Login Failed");
      console.error("Error Login customer:", error);
    } finally {
      setLoading(false);
    }
  };

  const [resetEmail, setResetEmail] = useState("");

  const handleResetPasswordCustomer = async (event) => {
    event.preventDefault();
    // const valid = validate();
    // setTimeout(() => {
    //   setFormErrors({});
    // }, 1500);
    // if (!valid) {
    //   showErrorToast("Passwords do not match.");
    //   return;
    // }
    // if (formData.password !== formData.confirmPassword) {
    //   showErrorToast("Passwords do not match.");
    //   return;
    // }

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);

    const raw = JSON.stringify({
      email: resetEmail,
      type: "customer",
      callbackUrl: "https://www.mountainmysteries.com/reset-password/customer",
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/accounts/send-password-reset-link`,
        requestOptions
      );

      const result = await response.json();
      if (result.success) {
        setResetSuccess(true);
        showSuccessToast(result.message || "Please Check Your Email.");
      } else {
        showErrorToast(result.message || "Password Reset Failed");
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
      showErrorToast("Password Reset Failed");
    }
  };

  const registerCustomer = async (e) => {
    e.preventDefault();
    const valid = validateSignup();

    if (!valid) {
      showErrorToast("Please fill the above details.");
      return;
    }
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const raw = JSON.stringify({
      type: "customer",
      name: formData?.name,
      email: formData?.email,
      callbackUrl: "https://mountainmysteries.com",
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/accounts/register`,
        requestOptions
      );
      const result = await response.json();
      if (result.success) {
        showSuccessToast(result.message);
        setIsLogin(true);
        setSignUp(false);
        setFormData({
          name: "",
          email: "",
        });
        setLoginErrors({
          email: "",
          password: "",
        });
      } else {
        showErrorToast(result.message);
      }
    } catch (error) {
      showErrorToast("Error registering Customer");
      console.error("Error registering user:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* <button
        type="button"
        onClick={handlePopUp}
        className={styles.popup_button}
      >
        {showPopUp ? "Close Form" : "Show Form"}
      </button> */}

      {isOpen && (
        <div className="bg_back_drop_overlay">
          {" "}
          <div className={styles.container}>
            <div className={styles.wrapper}>
              <div className={styles.wrapper_divider_left}>
                <div className={styles.wrapper_divider_left_svg}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="286"
                    height="170"
                    viewBox="0 0 286 170"
                    fill="none"
                  >
                    <path
                      d="M31.459 119.887C30.2282 120.019 28.8843 120.219 27.4548 120.512C21.3977 121.751 21.2692 125.877 21.3237 126.823L21.2809 126.796C20.6732 127.776 20.2915 128.769 20.0578 129.703L19.7812 117.053C19.9604 116.678 20.124 116.252 20.2603 115.819C20.7122 117.221 21.4562 118.542 22.0989 118.456C22.9324 118.343 23.2947 115.881 23.1389 114.134C24.1984 115.502 25.9824 116.967 26.6563 116.514C27.1938 116.155 26.8744 114.67 26.2901 113.318C27.5132 114.056 28.8687 114.541 29.2894 114.072C29.862 113.431 28.487 111.246 27.2211 110.027C28.9155 110.187 31.0734 109.914 31.2175 109.14C31.3344 108.503 30.049 107.698 28.674 107.178C30.0529 106.815 31.3461 106.178 31.3032 105.549C31.2526 104.803 29.3362 104.298 27.6807 104.224C28.9272 103.247 30.0723 101.891 29.7218 101.282C29.3985 100.719 27.9027 100.938 26.5199 101.434C27.3379 100.262 27.9144 98.9369 27.4743 98.4836C26.9289 97.9209 24.993 98.894 23.6686 99.9686C23.9257 98.2922 23.7972 96.178 23.0454 95.9866C22.4183 95.8263 21.5302 97.0573 20.9225 98.3977C20.6538 96.9909 20.1084 95.6544 19.4813 95.6544C18.5854 95.6544 17.8609 98.3625 17.8609 100.129C17.8609 100.23 17.8609 100.324 17.8687 100.414C17.7791 100.309 17.6739 100.199 17.5571 100.086C16.295 98.8549 13.8527 97.4911 13.2256 98.1358C12.7894 98.5891 13.3619 99.91 14.1799 101.086C12.7971 100.59 11.2975 100.371 10.9781 100.934C10.5457 101.688 12.3959 103.575 13.8995 104.49C13.8099 104.478 13.7125 104.47 13.6112 104.463C11.8545 104.341 9.11228 104.885 9.04996 105.779C9.00711 106.409 10.2964 107.046 11.6792 107.409C10.3042 107.929 9.02269 108.734 9.13566 109.371C9.27588 110.144 11.4338 110.418 13.1321 110.258C11.8662 111.477 10.4912 113.661 11.0638 114.302C11.4845 114.771 12.84 114.287 14.0631 113.548C13.4749 114.9 13.1594 116.385 13.6969 116.745C14.4059 117.221 16.3574 115.561 17.3818 114.134C17.2766 115.881 17.6934 118.28 18.5192 118.374C18.8659 118.413 19.232 118.042 19.5631 117.475L18.6283 131.071C18.4101 132.653 19.8085 133.689 19.9331 134.338L20.1357 143.544C19.9059 142.888 19.6021 142.216 19.1853 141.551L19.1424 141.579C19.197 140.633 19.0684 136.506 13.0114 135.268C11.5818 134.975 10.238 134.775 9.00711 134.642C7.5542 134.486 6.98551 136.483 8.29819 137.128C10.199 138.062 11.9869 139.238 12.9218 140.629C15.3056 144.189 18.5971 142.134 19.0684 141.813C19.5904 142.688 19.9331 143.568 20.1513 144.404L20.2603 149.293C20.2331 149.41 20.2175 149.472 20.2136 149.476L20.2642 149.492L20.5252 161.325L22.9324 161.305L22.0716 149.211C22.2157 148.558 22.6598 146.334 22.0716 144.029L21.2108 134.525L20.089 130.789C20.2526 129.633 20.6304 128.335 21.4016 127.05C21.8691 127.37 25.1644 129.429 27.5483 125.865C28.4792 124.474 30.271 123.298 32.1719 122.364C33.4845 121.719 32.9197 119.722 31.4629 119.879L31.459 119.887ZM20.4629 147.882L20.4161 145.811C20.5057 146.592 20.5018 147.3 20.4629 147.882Z"
                      fill="#F2F2F2"
                    />
                    <path
                      d="M0.5 161.895C0.5 162.153 0.706446 162.36 0.963529 162.36H285.036C285.294 162.36 285.5 162.153 285.5 161.895C285.5 161.637 285.294 161.43 285.036 161.43H0.963529C0.706446 161.43 0.5 161.637 0.5 161.895Z"
                      fill="#090814"
                    />
                    <path
                      d="M172.894 162.306C184.51 162.306 193.928 152.858 193.928 141.204C193.928 129.549 184.51 120.102 172.894 120.102C161.277 120.102 151.86 129.549 151.86 141.204C151.86 152.858 161.277 162.306 172.894 162.306Z"
                      fill="#090814"
                    />
                    <path
                      d="M172.894 155.272C180.638 155.272 186.916 148.973 186.916 141.204C186.916 133.434 180.638 127.136 172.894 127.136C165.149 127.136 158.871 133.434 158.871 141.204C158.871 148.973 165.149 155.272 172.894 155.272Z"
                      fill="white"
                    />
                    <path
                      d="M172.894 149.214C177.304 149.214 180.879 145.628 180.879 141.204C180.879 136.779 177.304 133.193 172.894 133.193C168.484 133.193 164.909 136.779 164.909 141.204C164.909 145.628 168.484 149.214 172.894 149.214Z"
                      fill="#090814"
                    />
                    <path
                      d="M51.3635 162.306C62.9803 162.306 72.3976 152.858 72.3976 141.204C72.3976 129.549 62.9803 120.102 51.3635 120.102C39.7467 120.102 30.3294 129.549 30.3294 141.204C30.3294 152.858 39.7467 162.306 51.3635 162.306Z"
                      fill="#090814"
                    />
                    <path
                      d="M51.3635 155.272C59.108 155.272 65.3862 148.973 65.3862 141.204C65.3862 133.434 59.108 127.136 51.3635 127.136C43.619 127.136 37.3408 133.434 37.3408 141.204C37.3408 148.973 43.619 155.272 51.3635 155.272Z"
                      fill="white"
                    />
                    <path
                      d="M201.668 131.168C198.929 124.24 189.355 103.071 172.302 96.0647C172.169 96.01 172.033 95.9748 171.893 95.9553L117.2 88.0967C116.3 87.9678 115.459 88.5852 115.315 89.4879L114.357 95.4277C114.29 95.8342 114.376 96.2523 114.598 96.6001C117.375 100.922 135.176 130.266 106.671 130.266C78.1664 130.266 70.3097 109.801 69.0633 106.186C68.9464 105.846 68.9425 105.479 69.0477 105.135L77.6873 77.6825C77.8392 77.194 77.7574 76.6938 77.5081 76.2952L81.3059 69.2182L88.2627 73.169L91.8658 73.212L104.163 79.6598L106.668 75.5567L81.3059 62.8642C81.3059 62.8642 81.3487 59.9255 73.1688 57.5809L60.3147 51.7192L58.7566 53.6731L62.6518 56.7993L63.0413 59.144L65.768 59.9255L71.2212 70.4765L69.6631 73.5012L71.5562 74.4273L71.0148 74.3023C70.2318 74.1225 69.4333 74.5289 69.1139 75.2675L60.5211 95.0252C60.3887 95.3261 60.1706 95.5841 59.894 95.7638L56.8324 97.7451C56.548 97.9287 56.3221 98.1984 56.1936 98.5149L52.6957 107.022C52.5866 107.288 52.5554 107.565 52.5827 107.835C48.224 108.663 35.4127 112.243 28.374 126.362L36.554 133.005C36.554 133.005 49.377 124.681 70.5668 133.349C74.2517 139.101 79.6232 143.873 87.3824 144.322C107.836 145.51 141.724 146.682 145.62 141.993C148.471 138.558 150.453 136.417 151.314 135.514C151.618 135.197 152.031 135.014 152.467 134.998L200.164 133.47C201.321 133.435 202.088 132.255 201.664 131.176L201.668 131.168Z"
                      fill="#EB442D"
                    />
                    <path
                      d="M70.0605 69.6911C73.5025 69.6911 76.2928 66.8917 76.2928 63.4386C76.2928 59.9855 73.5025 57.1862 70.0605 57.1862C66.6184 57.1862 63.8281 59.9855 63.8281 63.4386C63.8281 66.8917 66.6184 69.6911 70.0605 69.6911Z"
                      fill="#090814"
                    />
                    <path
                      d="M169.867 96.0921C169.793 96.0921 169.719 96.0921 169.645 96.0882L117.535 94.0639C115.229 93.9741 113.254 92.5008 112.503 90.3125L111.79 88.2296C111.209 86.5336 111.463 84.7126 112.483 83.2394C113.507 81.7661 115.12 80.8986 116.908 80.8556L170.747 79.6129C172.415 79.5739 174.019 80.289 175.106 81.5786C176.193 82.8681 176.637 84.5563 176.321 86.2171L175.305 91.563C174.802 94.2163 172.531 96.0882 169.863 96.0882L169.867 96.0921Z"
                      fill="#090814"
                    />
                    <path
                      d="M51.3635 149.214C55.7736 149.214 59.3487 145.628 59.3487 141.204C59.3487 136.779 55.7736 133.193 51.3635 133.193C46.9534 133.193 43.3783 136.779 43.3783 141.204C43.3783 145.628 46.9534 149.214 51.3635 149.214Z"
                      fill="#090814"
                    />
                    <path
                      d="M190.804 118.398C189.557 118.398 188.369 117.729 187.734 116.577L183.789 109.41C183.161 108.273 183.2 106.94 183.886 105.842C184.572 104.74 185.756 104.123 187.041 104.193L194.204 104.56C195.536 104.631 196.736 105.471 197.258 106.706L199.35 111.669C199.732 112.579 199.724 113.572 199.323 114.474C198.921 115.373 198.189 116.049 197.262 116.37L191.957 118.206C191.579 118.339 191.189 118.402 190.808 118.402L190.804 118.398Z"
                      fill="#090814"
                    />
                    <path
                      d="M100.221 166.03C100.163 166.03 100.1 166.03 100.042 166.018L98.4526 165.842C97.9345 165.784 97.4827 165.49 97.2178 165.037C96.9529 164.584 96.9179 164.048 97.1204 163.564L105.394 143.853C105.62 143.314 106.122 142.931 106.703 142.857C107.267 142.786 107.817 143.009 108.179 143.451C108.537 143.892 108.646 144.478 108.463 145.018L101.783 164.904C101.557 165.576 100.918 166.026 100.225 166.026L100.221 166.03Z"
                      fill="#090814"
                    />
                    <path
                      d="M143.173 28.4796C143.173 28.4796 140.147 22.4069 140.751 16.9438L130.678 22.1802L131.067 32.1216L143.173 28.4796Z"
                      fill="#DA8A8D"
                    />
                    <path
                      d="M136.922 24.986C141.94 24.986 146.009 20.9043 146.009 15.8692C146.009 10.8341 141.94 6.7523 136.922 6.7523C131.903 6.7523 127.834 10.8341 127.834 15.8692C127.834 20.9043 131.903 24.986 136.922 24.986Z"
                      fill="#DA8A8D"
                    />
                    <path
                      d="M146.204 159.019H140.657L138.02 137.561H146.204V159.019Z"
                      fill="#DA8A8D"
                    />
                    <path
                      d="M127.207 158.89C127.036 159.183 126.942 160.125 126.942 160.461C126.942 161.504 127.783 162.349 128.823 162.349H145.993C146.702 162.349 147.279 161.77 147.279 161.059V160.34C147.279 160.34 148.128 158.183 146.379 155.529C146.379 155.529 144.206 157.608 140.957 154.353L139.999 152.614L133.065 157.702L129.221 158.175C128.379 158.281 127.635 158.159 127.203 158.89L127.207 158.89Z"
                      fill="#090814"
                    />
                    <path
                      d="M129.856 28.4796L143.173 26.6585L153.464 31.5159L154.068 69.1635C154.068 69.1635 128.757 72.1999 124.769 68.253C120.78 64.3061 123.806 32.7312 123.806 32.7312L129.86 28.4796L129.856 28.4796Z"
                      fill="#EB442D"
                    />
                    <path
                      d="M134.647 18.1904H132.204C132.204 18.1904 130.085 15.5722 130.37 17.1665C130.654 18.7609 129.513 20.4764 129.513 20.4764L127.803 19.9059C127.803 19.9059 124.383 5.47445 134.647 4.68117C144.911 3.88789 147.193 11.8988 147.193 11.8988C147.193 11.8988 146.624 15.9043 145.483 14.7593C144.342 13.6144 138.071 13.0438 138.071 13.0438L134.651 18.1943L134.647 18.1904Z"
                      fill="#090814"
                    />
                    <path
                      d="M128.185 154.197L122.852 155.705L114.501 135.78L122.377 133.548L128.185 154.197Z"
                      fill="#DA8A8D"
                    />
                    <path
                      d="M109.869 159.254C109.784 159.582 109.951 160.512 110.041 160.84C110.321 161.844 111.361 162.427 112.362 162.145L128.886 157.464C129.567 157.272 129.965 156.557 129.774 155.873L129.579 155.182C129.579 155.182 129.813 152.876 127.409 150.797C127.409 150.797 125.883 153.392 121.874 151.141L120.48 149.726L115.186 156.51L111.618 158.015C110.839 158.343 110.088 158.433 109.869 159.254Z"
                      fill="#090814"
                    />
                    <path
                      d="M152.249 65.5215L154.064 71.0314V89.9647L148.615 147.112H137.973L136.774 106.319L137.72 86.1702L117.422 116.979L126.342 138.984L116.522 145.553C116.522 145.553 101.837 111.981 104.034 108.726C106.231 105.475 125.91 67.0729 125.91 67.0729C125.91 67.0729 152.241 66.1311 152.241 65.5254L152.249 65.5215Z"
                      fill="#090814"
                    />
                    <path
                      d="M157.699 43.6613L160.624 48.4679C160.624 48.4679 164.761 64.779 160.624 64.8454C156.487 64.9119 148.136 56.5336 148.136 56.5336L149.226 52.1608L152.253 53.3761L151.649 43.6613H157.702H157.699Z"
                      fill="#DA8A8D"
                    />
                    <path
                      d="M148.619 31.4417C148.619 31.4417 158.302 29.7301 159.21 36.088C160.117 42.446 160.624 48.4718 160.624 48.4718L150.13 49.3432L148.619 31.4417Z"
                      fill="#EB442D"
                    />
                    <path
                      d="M230.504 119.887C229.273 120.019 227.929 120.219 226.499 120.512C220.442 121.751 220.314 125.877 220.368 126.823L220.326 126.796C219.718 127.776 219.336 128.769 219.102 129.703L218.826 117.053C219.005 116.678 219.169 116.252 219.305 115.819C219.757 117.221 220.501 118.542 221.143 118.456C221.977 118.343 222.339 115.881 222.184 114.134C223.243 115.502 225.027 116.967 225.701 116.514C226.238 116.155 225.919 114.67 225.335 113.318C226.558 114.056 227.913 114.541 228.334 114.072C228.907 113.431 227.532 111.246 226.266 110.027C227.96 110.187 230.118 109.914 230.262 109.14C230.379 108.503 229.094 107.698 227.719 107.178C229.097 106.815 230.391 106.178 230.348 105.549C230.297 104.803 228.381 104.298 226.725 104.224C227.972 103.247 229.117 101.891 228.766 101.282C228.443 100.719 226.947 100.938 225.565 101.434C226.383 100.262 226.959 98.9369 226.519 98.4836C225.974 97.9209 224.038 98.894 222.713 99.9686C222.97 98.2922 222.842 96.178 222.09 95.9866C221.463 95.8263 220.575 97.0573 219.967 98.3977C219.698 96.9909 219.153 95.6544 218.526 95.6544C217.63 95.6544 216.906 98.3625 216.906 100.129C216.906 100.23 216.906 100.324 216.913 100.414C216.824 100.309 216.719 100.199 216.602 100.086C215.34 98.8549 212.897 97.4911 212.27 98.1358C211.834 98.5891 212.407 99.91 213.225 101.086C211.842 100.59 210.342 100.371 210.023 100.934C209.59 101.688 211.441 103.575 212.944 104.49C212.855 104.478 212.757 104.47 212.656 104.463C210.899 104.341 208.157 104.885 208.095 105.779C208.052 106.409 209.341 107.046 210.724 107.409C209.349 107.929 208.067 108.734 208.18 109.371C208.321 110.144 210.478 110.418 212.177 110.258C210.911 111.477 209.536 113.661 210.108 114.302C210.529 114.771 211.885 114.287 213.108 113.548C212.52 114.9 212.204 116.385 212.742 116.745C213.451 117.221 215.402 115.561 216.426 114.134C216.321 115.881 216.738 118.28 217.564 118.374C217.911 118.413 218.277 118.042 218.608 117.475L217.673 131.071C217.455 132.653 218.853 133.689 218.978 134.338L219.18 143.544C218.951 142.888 218.647 142.216 218.23 141.551L218.187 141.579C218.242 140.633 218.113 136.506 212.056 135.268C210.626 134.975 209.283 134.775 208.052 134.642C206.599 134.486 206.03 136.483 207.343 137.128C209.244 138.062 211.032 139.238 211.966 140.629C214.35 144.189 217.642 142.134 218.113 141.813C218.635 142.688 218.978 143.568 219.196 144.404L219.305 149.293C219.278 149.41 219.262 149.472 219.258 149.476L219.309 149.492L219.57 161.325L221.977 161.305L221.116 149.211C221.26 148.558 221.704 146.334 221.116 144.029L220.255 134.525L219.134 130.789C219.297 129.633 219.675 128.335 220.446 127.05C220.914 127.37 224.209 129.429 226.593 125.865C227.524 124.474 229.316 123.298 231.217 122.364C232.529 121.719 231.964 119.722 230.508 119.879L230.504 119.887ZM219.508 147.882L219.461 145.811C219.55 146.592 219.546 147.3 219.508 147.882Z"
                      fill="#F2F2F2"
                    />
                    <path
                      d="M202.47 159.855L206.657 158.949L205.158 142.325L198.984 143.662L202.47 159.855Z"
                      fill="#DA8A8D"
                    />
                    <path
                      d="M216.789 156.655C216.968 156.846 217.19 157.542 217.244 157.8C217.416 158.585 216.917 159.363 216.13 159.531L203.171 162.341C202.637 162.458 202.108 162.114 201.991 161.579L201.874 161.036C201.874 161.036 200.881 159.547 201.769 157.257C201.769 157.257 203.748 158.472 205.668 155.479L206.108 154.009L212.169 156.714L215.145 156.444C215.795 156.385 216.341 156.17 216.785 156.655L216.789 156.655Z"
                      fill="#090814"
                    />
                    <path
                      d="M209.957 158.585L213.447 156.1L205.551 141.407L200.398 145.072L209.957 158.585Z"
                      fill="#DA8A8D"
                    />
                    <path
                      d="M221.864 149.988C222.102 150.094 222.581 150.645 222.729 150.86C223.192 151.516 223.04 152.427 222.386 152.892L211.573 160.59C211.125 160.907 210.51 160.801 210.19 160.356L209.871 159.902C209.871 159.902 208.375 158.925 208.293 156.467C208.293 156.467 210.588 156.803 211.183 153.294L211.012 151.77L217.646 151.864L220.279 150.442C220.855 150.129 221.272 149.719 221.868 149.988H221.864Z"
                      fill="#090814"
                    />
                    <path
                      d="M159.658 76.3851C159.658 76.3851 153.149 85.2636 166.167 95.248L192.751 86.7251L183.255 66.8579L174.845 62.2311L159.654 76.3812L159.658 76.3851Z"
                      fill="#090814"
                    />
                    <path
                      d="M192.755 86.729L203.062 106.866L209.575 148.781L201.438 149.324L193.297 109.59L178.92 88.0889L188.958 83.4621"
                      fill="#090814"
                    />
                    <path
                      d="M166.171 88.9252V95.2519L184.618 115.576C184.618 115.576 184.618 130.817 191.672 137.894L199.81 150.414L206.864 146.604L196.557 110.137L178.109 86.1858L166.174 88.9252L166.171 88.9252Z"
                      fill="#090814"
                    />
                    <path
                      d="M179.278 26.2092L175.803 39.4995L162.556 36.8852C162.556 36.8852 171.799 27.3229 170.498 22.9657L179.282 26.2092H179.278Z"
                      fill="#DA8A8D"
                    />
                    <path
                      d="M169.154 28.2138L177.291 32.0239C177.291 32.0239 181.479 34.5914 181.557 36.303C181.635 38.0146 181.089 46.1779 181.089 46.1779C181.089 46.1779 184.346 49.4448 182.176 55.9747L183.263 66.8618L158.848 79.9256L161.017 57.065L159.93 35.8379L169.154 28.2178V28.2138Z"
                      fill="#090814"
                    />
                    <path
                      d="M161.851 90.1601C162.805 92.3523 164.706 93.638 166.097 93.0284C167.487 92.4188 167.842 90.1483 166.891 87.9561C166.521 87.0729 165.949 86.2952 165.216 85.6817L161.06 76.4398L156.779 78.4875L161.329 87.3816C161.278 88.3351 161.457 89.2886 161.851 90.1601Z"
                      fill="#DA8A8D"
                    />
                    <path
                      d="M166.171 37.1978C166.171 37.1978 160.203 33.3878 158.034 37.741C155.864 42.0943 150.979 64.4117 150.979 64.4117L158.034 85.6387L164.542 82.9189L158.844 60.074L166.167 37.1978L166.171 37.1978Z"
                      fill="#090814"
                    />
                    <path
                      d="M196.76 86.7329C198.45 88.4211 200.69 88.9135 201.761 87.831C202.832 86.7486 202.326 84.5094 200.635 82.8212C199.969 82.1374 199.147 81.6255 198.244 81.3246L190.987 74.2671L187.758 77.7528L195.252 84.3375C195.556 85.2441 196.074 86.0647 196.76 86.729V86.7329Z"
                      fill="#DA8A8D"
                    />
                    <path
                      d="M181.327 35.8965C181.327 35.8965 170.923 35.4706 170.502 40.3202C170.085 45.1697 177.198 66.811 177.198 66.811L191.552 83.9389L196.604 79.0033L182.92 59.8708L181.331 35.8965L181.327 35.8965Z"
                      fill="#090814"
                    />
                    <path
                      d="M228.615 164.885C230.43 164.885 231.902 163.408 231.902 161.587C231.902 159.765 230.43 158.288 228.615 158.288C226.799 158.288 225.327 159.765 225.327 161.587C225.327 163.408 226.799 164.885 228.615 164.885Z"
                      fill="#090814"
                    />
                    <path
                      d="M232.997 170C234.812 170 236.284 168.523 236.284 166.702C236.284 164.88 234.812 163.404 232.997 163.404C231.181 163.404 229.709 164.88 229.709 166.702C229.709 168.523 231.181 170 232.997 170Z"
                      fill="#090814"
                    />
                    <path
                      d="M265.864 170C267.68 170 269.152 168.523 269.152 166.702C269.152 164.88 267.68 163.404 265.864 163.404C264.049 163.404 262.577 164.88 262.577 166.702C262.577 168.523 264.049 170 265.864 170Z"
                      fill="#090814"
                    />
                    <path
                      d="M237.811 117.347V81.5317C237.811 77.5223 241.153 76.5297 245.15 76.5297C247.109 76.5297 248.059 76.3031 249.434 77.702C250.809 79.101 252.336 79.6833 252.305 81.6489L251.729 116.792L237.807 117.343L237.811 117.347ZM245.539 78.8783C241.971 78.8783 238.59 77.956 238.59 81.5356V116.538L250.965 116.045L251.53 81.6411C251.557 79.8865 248.714 80.1288 247.491 78.8783C246.264 77.6278 247.292 78.8783 245.543 78.8783L245.539 78.8783Z"
                      fill="#090814"
                    />
                    <path
                      d="M228.026 116.913L227.528 156.041C227.52 156.546 227.641 157.042 227.874 157.487L231.559 164.47C232.101 165.498 233.184 166.12 234.34 166.069L266.694 164.639C268.349 164.564 269.631 163.157 269.557 161.497L267.528 116.819C267.454 115.213 266.137 113.947 264.532 113.947H231.022C229.382 113.947 228.046 115.271 228.022 116.917L228.026 116.913Z"
                      fill="#CACACA"
                    />
                    <path
                      d="M240.779 134.572L240 134.533L240.288 128.742C240.444 125.623 243.003 123.122 246.116 123.048L259.893 122.728C262.674 122.681 264.98 124.795 265.132 127.585L265.424 132.88L264.645 132.923L264.353 127.628C264.221 125.264 262.253 123.45 259.909 123.509L246.131 123.829C243.424 123.892 241.2 126.069 241.064 128.781L240.775 134.572L240.779 134.572Z"
                      fill="#090814"
                    />
                    <path
                      d="M240.23 162.622L239.455 162.544L241.134 146.108C241.445 143.068 243.973 140.672 247.015 140.535L260.454 139.93C262.148 139.851 263.757 140.453 264.988 141.622C266.219 142.79 266.904 144.369 266.924 146.069L267.076 160.379L266.297 160.387L266.145 146.077C266.129 144.592 265.529 143.212 264.454 142.188C263.379 141.164 261.965 140.641 260.493 140.707L247.054 141.313C244.394 141.434 242.185 143.525 241.913 146.182L240.234 162.618L240.23 162.622Z"
                      fill="#090814"
                    />
                    <path
                      d="M234.208 161.485L233.429 161.473L233.92 123.912C233.955 121.344 235.984 119.273 238.543 119.195L265.031 118.413L265.054 119.195L238.567 119.976C236.424 120.039 234.726 121.77 234.699 123.919L234.208 161.481V161.485Z"
                      fill="#090814"
                    />
                    <path
                      d="M234.278 156.135H233.737V121.926C233.737 120.844 232.86 119.961 231.777 119.961H228.751V119.179H231.777C233.207 119.179 234.383 120.285 234.504 121.684C234.512 121.762 234.516 121.844 234.516 121.926V138.124L234.278 156.135Z"
                      fill="#090814"
                    />
                    <path
                      d="M184.934 19.1048C184.934 24.1146 180.887 28.1748 175.893 28.1748C170.899 28.1748 166.852 24.1146 166.852 19.1048C166.852 14.095 170.899 10.0348 175.893 10.0348C180.887 10.0348 184.934 14.095 184.934 19.1048Z"
                      fill="#DA8A8D"
                    />
                    <path
                      d="M175.172 6.91251C175.433 7.06491 175.784 6.83436 175.87 6.54127C175.955 6.24819 175.854 5.93947 175.761 5.6503C175.597 5.16573 175.437 4.68507 175.274 4.20051C174.927 3.17276 174.561 2.10984 173.813 1.32829C172.683 0.148136 170.884 -0.152764 169.267 0.0660722C167.191 0.347433 165.142 1.47287 164.176 3.3408C163.21 5.20872 163.623 7.8113 165.368 8.97582C162.879 11.8363 162.014 15.0251 162.151 18.8156C162.287 22.6101 166.408 26.0997 169.096 28.7727C169.696 28.4092 170.241 26.6976 169.91 26.0763C169.579 25.455 170.054 24.7359 169.645 24.1615C169.236 23.5909 168.893 24.5015 169.306 23.9309C169.567 23.5714 168.551 22.7469 168.936 22.5319C170.81 21.4925 171.433 19.1478 172.609 17.3541C174.031 15.1892 176.458 13.7238 179.033 13.4815C180.45 13.3486 181.946 13.5909 183.107 14.4155C184.268 15.24 185.019 16.7132 184.751 18.1161C185.448 17.4049 185.795 16.3654 185.666 15.3768C185.534 14.3881 184.93 13.4737 184.069 12.9696C184.591 11.2384 184.143 9.24546 182.932 7.909C181.72 6.56863 176.808 6.79919 175.04 7.15089L175.176 6.91642L175.172 6.91251Z"
                      fill="#090814"
                    />
                    <path
                      d="M174.9 13.5323C172.559 13.7863 170.868 15.8223 169.439 17.7019C168.617 18.7844 167.752 19.9801 167.775 21.344C167.795 22.7195 168.714 23.9036 169.154 25.2049C169.871 27.3385 169.174 29.8747 167.468 31.3362C169.154 31.6566 170.977 30.3905 171.266 28.6906C171.604 26.7172 170.113 24.8102 170.288 22.8133C170.444 21.0548 171.826 19.7027 172.999 18.3858C174.175 17.0688 175.278 15.326 174.736 13.6456L174.9 13.5323Z"
                      fill="#090814"
                    />
                    <path
                      d="M127.123 73.598L113.458 61.916C113.133 61.6385 113.108 61.1322 113.401 60.7873L135.532 34.7327C135.825 34.3878 136.327 34.3328 136.652 34.6103L150.316 46.2923C150.641 46.5698 150.667 47.0761 150.374 47.421L128.243 73.4757C127.95 73.8206 127.447 73.8755 127.123 73.598Z"
                      fill="white"
                    />
                    <path
                      d="M120.538 36.1154L115.038 37.2565C115.038 37.2565 100.338 45.3729 103.119 48.4484C105.896 51.5238 117.703 51.9185 117.703 51.9185L120.141 48.1318L117.188 46.7446L124.675 40.5507L120.538 36.1154Z"
                      fill="#DA8A8D"
                    />
                    <path
                      d="M135.636 34.4155C135.636 34.4155 130.265 26.1505 125.018 29.8317C119.771 33.5128 115.042 37.2565 115.042 37.2565L121.578 45.5371L135.64 34.4155H135.636Z"
                      fill="#EB442D"
                    />
                    <path
                      d="M127.034 51.8325C127.333 50.3475 125.178 48.6569 122.22 48.0563C119.261 47.4557 116.62 48.1727 116.321 49.6576C116.021 51.1426 118.177 52.8333 121.135 53.4338C124.093 54.0344 126.734 53.3175 127.034 51.8325Z"
                      fill="#DA8A8D"
                    />
                    <path
                      d="M150.722 56.0013C151.598 54.7673 150.316 52.3428 147.857 50.5862C145.399 48.8296 142.696 48.4059 141.82 49.64C140.944 50.874 142.226 53.2985 144.685 55.0551C147.143 56.8117 149.846 57.2354 150.722 56.0013Z"
                      fill="#DA8A8D"
                    />
                  </svg>
                </div>

                <div className={styles.wrapper_divider_left_heading}>
                  <h2>Find Your Himachal Escape Now</h2>
                </div>

                <div className={styles.wrapper_divider_left_bottom_section}>
                  <div
                    className={
                      styles.wrapper_divider_left_bottom_section_heading
                    }
                  >
                    <p>explore himachal’s best:</p>
                  </div>
                  <div
                    className={
                      styles.wrapper_divider_left_bottom_section_content
                    }
                  >
                    <div
                      className={
                        styles.wrapper_divider_left_bottom_section_content_rounded
                      }
                    >
                      <p>Holidays</p>
                    </div>

                    <div
                      className={
                        styles.wrapper_divider_left_bottom_section_content_rounded
                      }
                    >
                      <p>Hotels</p>
                    </div>

                    <div
                      className={
                        styles.wrapper_divider_left_bottom_section_content_rounded
                      }
                    >
                      <p>Activities</p>
                    </div>

                    <div
                      className={
                        styles.wrapper_divider_left_bottom_section_content_rounded
                      }
                    >
                      <p>Transport</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.wrapper_divider_right}>
                {isLogin && (
                  <>
                    <div className={styles.wrapper_divider_right_header}>
                      {isLogin && !logInSuccess && (
                        <>
                          {" "}
                          <h2>Log In</h2>{" "}
                          <button>
                            <svg
                              onClick={() => setIsOpen(false)}
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M1.12203 20L0 18.878L8.87797 10L0 1.12203L1.12203 0L10 8.87797L18.878 0L20 1.12203L11.122 10L20 18.878L18.878 20L10 11.122L1.12203 20Z"
                                fill="#1C1B1F"
                              />
                            </svg>
                          </button>
                        </>
                      )}
                    </div>
                    <div className={styles.wrapper_divider_right_form_content}>
                      <form onSubmit={loginCustomer}>
                        <div
                          className={
                            styles.wrapper_divider_right_form_content_input
                          }
                        >
                          <label htmlFor="email">Email</label>
                          <input
                            className="w-100"
                            value={formData?.email}
                            onChange={handleFormChangeData}
                            name="email"
                            placeholder="Enter email address"
                            style={
                              loginErrors.email
                                ? {
                                    borderBottom: "1px solid red",
                                  }
                                : { borderBottom: "1px solid #333" }
                            }
                          />
                        </div>

                        <div
                          className={
                            styles.wrapper_divider_right_form_content_input
                          }
                        >
                          <label htmlFor="password">Password</label>
                          <input
                            type="password"
                            name="password"
                            value={formData?.password}
                            placeholder="Enter password"
                            id="password"
                            onChange={handleFormChangeData}
                            className="custom-style"
                            style={
                              loginErrors.password
                                ? {
                                    borderBottom: "1px solid red",
                                  }
                                : { borderBottom: "1px solid #333" }
                            }
                          />
                          {isLogin &&
                            (loginErrors.email || loginErrors.password) && (
                              <p
                                style={{
                                  color: "red",
                                  fontSize: "12px",
                                  marginTop: "4px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                }}
                              >
                                <svg
                                  width="14"
                                  height="14"
                                  viewBox="0 0 14 14"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <mask
                                    id="mask0"
                                    style={{ maskType: "alpha" }}
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="14"
                                    height="14"
                                  >
                                    <rect
                                      width="14"
                                      height="14"
                                      fill="#D9D9D9"
                                    />
                                  </mask>
                                  <g mask="url(#mask0)">
                                    <path
                                      d="M7.00008 9.91669C7.16536 9.91669 7.3039 9.86079 7.41571 9.74898C7.52751 9.63717 7.58342 9.49863 7.58342 9.33335C7.58342 9.16808 7.52751 9.02953 7.41571 8.91773C7.3039 8.80592 7.16536 8.75002 7.00008 8.75002C6.8348 8.75002 6.69626 8.80592 6.58446 8.91773C6.47265 9.02953 6.41675 9.16808 6.41675 9.33335C6.41675 9.49863 6.47265 9.63717 6.58446 9.74898C6.69626 9.86079 6.8348 9.91669 7.00008 9.91669ZM6.41675 7.58335H7.58342V4.08335H6.41675V7.58335ZM7.00008 12.8334C6.19314 12.8334 5.4348 12.6802 4.72508 12.374C4.01536 12.0677 3.398 11.6521 2.873 11.1271C2.348 10.6021 1.93237 9.98474 1.62612 9.27502C1.31987 8.5653 1.16675 7.80697 1.16675 7.00002C1.16675 6.19308 1.31987 5.43474 1.62612 4.72502C1.93237 4.0153 2.348 3.39794 2.873 2.87294C3.398 2.34794 4.01536 1.93231 4.72508 1.62606C5.4348 1.31981 6.19314 1.16669 7.00008 1.16669C7.80703 1.16669 8.56536 1.31981 9.27508 1.62606C9.9848 1.93231 10.6022 2.34794 11.1272 2.87294C11.6522 3.39794 12.0678 4.0153 12.374 4.72502C12.6803 5.43474 12.8334 6.19308 12.8334 7.00002C12.8334 7.80697 12.6803 8.5653 12.374 9.27502C12.0678 9.98474 11.6522 10.6021 11.1272 11.1271C10.6022 11.6521 9.9848 12.0677 9.27508 12.374C8.56536 12.6802 7.80703 12.8334 7.00008 12.8334Z"
                                      fill="#EB442D"
                                    />
                                  </g>
                                </svg>
                                {loginErrors.email && loginErrors.password
                                  ? "Please enter a valid email and password"
                                  : loginErrors.email
                                  ? "Please enter a valid email"
                                  : "Please enter a valid password"}
                              </p>
                            )}
                        </div>
                        <div
                          className={
                            styles.wrapper_divider_right_form_content_button
                          }
                        >
                          <button type="submit">
                            <p>
                              Log In
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="16"
                                viewBox="0 0 15 16"
                                fill="none"
                              >
                                <mask
                                  id="mask0_7937_5206"
                                  style={{ maskType: "alpha" }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="15"
                                  height="16"
                                >
                                  <rect
                                    y="0.5"
                                    width="15"
                                    height="15"
                                    fill="#D9D9D9"
                                  />
                                </mask>
                                <g mask="url(#mask0_7937_5206)">
                                  <path
                                    d="M10.3919 8.46851H3.28125C3.14823 8.46851 3.03687 8.42361 2.94719 8.33382C2.8574 8.24414 2.8125 8.13278 2.8125 7.99976C2.8125 7.86674 2.8574 7.75539 2.94719 7.6657C3.03687 7.57591 3.14823 7.53101 3.28125 7.53101H10.3919L7.16109 4.30023C7.06818 4.20731 7.02229 4.09856 7.02344 3.97398C7.02469 3.8494 7.07375 3.73861 7.17063 3.64164C7.2676 3.55111 7.3774 3.50424 7.5 3.50101C7.6226 3.49778 7.7324 3.54466 7.82938 3.64164L11.792 7.60429C11.8506 7.66283 11.8918 7.72455 11.9158 7.78945C11.9398 7.85434 11.9519 7.92445 11.9519 7.99976C11.9519 8.07507 11.9398 8.14518 11.9158 8.21007C11.8918 8.27497 11.8506 8.33669 11.792 8.39523L7.82938 12.3579C7.74281 12.4444 7.63563 12.4887 7.50781 12.4907C7.38 12.4927 7.2676 12.4484 7.17063 12.3579C7.07375 12.2609 7.02531 12.1496 7.02531 12.0238C7.02531 11.898 7.07375 11.7866 7.17063 11.6896L10.3919 8.46851Z"
                                    fill="white"
                                  />
                                </g>
                              </svg>
                            </p>
                          </button>

                          {/* Below text links */}
                          <div
                            className={
                              styles.wrapper_divider_right_bottom_content
                            }
                          >
                            <span>
                              Forgot your password?{" "}
                              <button
                                onClick={() => {
                                  setReset(true);
                                  setIsLogin(false);
                                }}
                              >
                                reset
                              </button>
                            </span>
                          </div>
                        </div>
                      </form>{" "}
                    </div>
                    <div
                      className={styles.wrapper_divider_right_bottom_content}
                    >
                      {isLogin && !logInSuccess && (
                        <span>
                          Don't have an account?{" "}
                          <button
                            onClick={() => {
                              setSignUp(true);
                              setIsLogin(false);
                              setFormData({
                                name: "",
                                email: "",
                              });
                            }}
                          >
                            sign up
                          </button>
                        </span>
                      )}
                    </div>
                  </>
                )}
                {reset && (
                  <>
                    <div className={styles.wrapper_divider_right_header}>
                      {reset && !resetSuccess && (
                        <>
                          <h2>Reset Password</h2>{" "}
                          <button>
                            <svg
                              onClick={() => setIsOpen(false)}
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M1.12203 20L0 18.878L8.87797 10L0 1.12203L1.12203 0L10 8.87797L18.878 0L20 1.12203L11.122 10L20 18.878L18.878 20L10 11.122L1.12203 20Z"
                                fill="#1C1B1F"
                              />
                            </svg>
                          </button>
                        </>
                      )}
                    </div>
                    <div className={styles.wrapper_divider_right_form_content}>
                      <form onSubmit={handleResetPasswordCustomer}>
                        <div
                          className={
                            styles.wrapper_divider_right_form_content_input
                          }
                        >
                          <label htmlFor="email">Email</label>
                          <input
                            className="w-100"
                            value={resetEmail}
                            onChange={(e) => setResetEmail(e.target.value)}
                            name="resetEmail"
                            placeholder="Enter email address"
                            style={
                              loginErrors.resetEmail
                                ? {
                                    borderBottom: "1px solid red",
                                  }
                                : { borderBottom: "1px solid #333" }
                            }
                          />
                        </div>

                        <div
                          className={
                            styles.wrapper_divider_right_form_content_button
                          }
                        >
                          <button type="submit">
                            <p>
                              Reset Password
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="16"
                                viewBox="0 0 15 16"
                                fill="none"
                              >
                                <mask
                                  id="mask0_7937_5206"
                                  style={{ maskType: "alpha" }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="15"
                                  height="16"
                                >
                                  <rect
                                    y="0.5"
                                    width="15"
                                    height="15"
                                    fill="#D9D9D9"
                                  />
                                </mask>
                                <g mask="url(#mask0_7937_5206)">
                                  <path
                                    d="M10.3919 8.46851H3.28125C3.14823 8.46851 3.03687 8.42361 2.94719 8.33382C2.8574 8.24414 2.8125 8.13278 2.8125 7.99976C2.8125 7.86674 2.8574 7.75539 2.94719 7.6657C3.03687 7.57591 3.14823 7.53101 3.28125 7.53101H10.3919L7.16109 4.30023C7.06818 4.20731 7.02229 4.09856 7.02344 3.97398C7.02469 3.8494 7.07375 3.73861 7.17063 3.64164C7.2676 3.55111 7.3774 3.50424 7.5 3.50101C7.6226 3.49778 7.7324 3.54466 7.82938 3.64164L11.792 7.60429C11.8506 7.66283 11.8918 7.72455 11.9158 7.78945C11.9398 7.85434 11.9519 7.92445 11.9519 7.99976C11.9519 8.07507 11.9398 8.14518 11.9158 8.21007C11.8918 8.27497 11.8506 8.33669 11.792 8.39523L7.82938 12.3579C7.74281 12.4444 7.63563 12.4887 7.50781 12.4907C7.38 12.4927 7.2676 12.4484 7.17063 12.3579C7.07375 12.2609 7.02531 12.1496 7.02531 12.0238C7.02531 11.898 7.07375 11.7866 7.17063 11.6896L10.3919 8.46851Z"
                                    fill="white"
                                  />
                                </g>
                              </svg>
                            </p>
                          </button>
                        </div>
                        <div
                          className={
                            styles.wrapper_divider_right_bottom_content
                          }
                        >
                          <span>
                            Back To{" "}
                            <button
                              onClick={() => {
                                setReset(false);
                                setIsLogin(true);
                              }}
                            >
                              Log In
                            </button>
                          </span>
                        </div>
                      </form>{" "}
                    </div>
                    <div></div>
                  </>
                )}
                {signUp && (
                  <>
                    <div className={styles.wrapper_divider_right_header}>
                      <h2>Sign Up</h2>
                      <button>
                        <svg
                          onClick={() => setIsOpen(false)}
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M1.12203 20L0 18.878L8.87797 10L0 1.12203L1.12203 0L10 8.87797L18.878 0L20 1.12203L11.122 10L20 18.878L18.878 20L10 11.122L1.12203 20Z"
                            fill="#1C1B1F"
                          />
                        </svg>
                      </button>
                    </div>
                    <div className={styles.wrapper_divider_right_form_content}>
                      <form onSubmit={registerCustomer}>
                        <div
                          className={
                            styles.wrapper_divider_right_form_content_input
                          }
                        >
                          <label htmlFor="name">Full Name</label>
                          <input
                            className="w-full"
                            value={formData.name}
                            onChange={handleFormChangeData}
                            name="name"
                            type="text"
                            placeholder="Enter full name"
                            style={
                              signupErrors.name
                                ? {
                                    borderBottom: "1px solid red",
                                  }
                                : { borderBottom: "1px solid #333" }
                            }
                          />
                        </div>
                        <div
                          className={
                            styles.wrapper_divider_right_form_content_input
                          }
                        >
                          <label htmlFor="email">Email</label>
                          <input
                            className="w-100"
                            value={formData?.email}
                            onChange={handleFormChangeData}
                            name="email"
                            placeholder="Enter email address"
                            style={
                              signupErrors.email
                                ? {
                                    borderBottom: "1px solid red",
                                  }
                                : { borderBottom: "1px solid #333" }
                            }
                          />
                          {(signupErrors.email || signupErrors.name) && (
                            <p
                              style={{
                                color: "red",
                                fontSize: "12px",
                                marginTop: "4px",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <mask
                                  id="mask0"
                                  style={{ maskType: "alpha" }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="14"
                                  height="14"
                                >
                                  <rect width="14" height="14" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0)">
                                  <path
                                    d="M7.00008 9.91669C7.16536 9.91669 7.3039 9.86079 7.41571 9.74898C7.52751 9.63717 7.58342 9.49863 7.58342 9.33335C7.58342 9.16808 7.52751 9.02953 7.41571 8.91773C7.3039 8.80592 7.16536 8.75002 7.00008 8.75002C6.8348 8.75002 6.69626 8.80592 6.58446 8.91773C6.47265 9.02953 6.41675 9.16808 6.41675 9.33335C6.41675 9.49863 6.47265 9.63717 6.58446 9.74898C6.69626 9.86079 6.8348 9.91669 7.00008 9.91669ZM6.41675 7.58335H7.58342V4.08335H6.41675V7.58335ZM7.00008 12.8334C6.19314 12.8334 5.4348 12.6802 4.72508 12.374C4.01536 12.0677 3.398 11.6521 2.873 11.1271C2.348 10.6021 1.93237 9.98474 1.62612 9.27502C1.31987 8.5653 1.16675 7.80697 1.16675 7.00002C1.16675 6.19308 1.31987 5.43474 1.62612 4.72502C1.93237 4.0153 2.348 3.39794 2.873 2.87294C3.398 2.34794 4.01536 1.93231 4.72508 1.62606C5.4348 1.31981 6.19314 1.16669 7.00008 1.16669C7.80703 1.16669 8.56536 1.31981 9.27508 1.62606C9.9848 1.93231 10.6022 2.34794 11.1272 2.87294C11.6522 3.39794 12.0678 4.0153 12.374 4.72502C12.6803 5.43474 12.8334 6.19308 12.8334 7.00002C12.8334 7.80697 12.6803 8.5653 12.374 9.27502C12.0678 9.98474 11.6522 10.6021 11.1272 11.1271C10.6022 11.6521 9.9848 12.0677 9.27508 12.374C8.56536 12.6802 7.80703 12.8334 7.00008 12.8334Z"
                                    fill="#EB442D"
                                  />
                                </g>
                              </svg>
                              {signupErrors.name && signupErrors.email
                                ? "Please enter a valid email and name"
                                : signupErrors.email
                                ? "Please enter a valid email"
                                : "Please enter a valid name"}
                            </p>
                          )}
                        </div>

                        <div
                          className={
                            styles.wrapper_divider_right_form_content_button
                          }
                        >
                          <button type="submit">
                            <p>
                              Sign Up
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="16"
                                viewBox="0 0 15 16"
                                fill="none"
                              >
                                <mask
                                  id="mask0_7937_5206"
                                  style={{ maskType: "alpha" }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="15"
                                  height="16"
                                >
                                  <rect
                                    y="0.5"
                                    width="15"
                                    height="15"
                                    fill="#D9D9D9"
                                  />
                                </mask>
                                <g mask="url(#mask0_7937_5206)">
                                  <path
                                    d="M10.3919 8.46851H3.28125C3.14823 8.46851 3.03687 8.42361 2.94719 8.33382C2.8574 8.24414 2.8125 8.13278 2.8125 7.99976C2.8125 7.86674 2.8574 7.75539 2.94719 7.6657C3.03687 7.57591 3.14823 7.53101 3.28125 7.53101H10.3919L7.16109 4.30023C7.06818 4.20731 7.02229 4.09856 7.02344 3.97398C7.02469 3.8494 7.07375 3.73861 7.17063 3.64164C7.2676 3.55111 7.3774 3.50424 7.5 3.50101C7.6226 3.49778 7.7324 3.54466 7.82938 3.64164L11.792 7.60429C11.8506 7.66283 11.8918 7.72455 11.9158 7.78945C11.9398 7.85434 11.9519 7.92445 11.9519 7.99976C11.9519 8.07507 11.9398 8.14518 11.9158 8.21007C11.8918 8.27497 11.8506 8.33669 11.792 8.39523L7.82938 12.3579C7.74281 12.4444 7.63563 12.4887 7.50781 12.4907C7.38 12.4927 7.2676 12.4484 7.17063 12.3579C7.07375 12.2609 7.02531 12.1496 7.02531 12.0238C7.02531 11.898 7.07375 11.7866 7.17063 11.6896L10.3919 8.46851Z"
                                    fill="white"
                                  />
                                </g>
                              </svg>
                            </p>
                          </button>
                        </div>
                        <div
                          className={
                            styles.wrapper_divider_right_bottom_content
                          }
                        >
                          <span>
                            Have an account?{" "}
                            <button
                              onClick={() => {
                                setSignUp(false);
                                setIsLogin(true);
                                setFormData({
                                  name: "",
                                  email: "",
                                });
                              }}
                            >
                              sign in
                            </button>
                          </span>
                        </div>
                      </form>{" "}
                    </div>
                    <div></div>
                  </>
                )}

                {resetSuccess && (
                  <div className={styles.reset_success}>
                    <div>
                      {" "}
                      <svg
                        width="70"
                        height="71"
                        viewBox="0 0 70 71"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_7967_8694"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="70"
                          height="71"
                        >
                          <rect y="0.5" width="70" height="70" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_7967_8694)">
                          <path
                            d="M35.0002 3.41663L61.396 19.1666C62.271 19.7013 62.9515 20.4305 63.4377 21.3541C63.9238 22.2777 64.1668 23.25 64.1668 24.2708V55.9166C64.1668 57.5208 63.5956 58.8941 62.4533 60.0364C61.3109 61.1788 59.9377 61.75 58.3335 61.75H11.6668C10.0627 61.75 8.6894 61.1788 7.54704 60.0364C6.40468 58.8941 5.8335 57.5208 5.8335 55.9166V24.2708C5.8335 23.25 6.07655 22.2777 6.56266 21.3541C7.04877 20.4305 7.72933 19.7013 8.60433 19.1666L35.0002 3.41663ZM35.0002 37.3958L57.7502 23.8333L35.0002 10.2708L12.2502 23.8333L35.0002 37.3958Z"
                            fill="#009A50"
                          />
                        </g>
                      </svg>
                    </div>

                    <h2>Check Mailbox</h2>
                    <p>
                      A message has been sent to your registered e-mail address
                      to confirm your password reset.
                    </p>
                    <div
                      className={
                        styles.wrapper_divider_right_form_content_button
                      }
                    >
                      <button
                        onClick={() => {
                          setResetSuccess(false);
                          setReset(false);
                          setIsLogin(true);
                          setFormData({
                            name: "",
                            email: "",
                          });
                        }}
                      >
                        <p>
                          Log In Again
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="16"
                            viewBox="0 0 15 16"
                            fill="none"
                          >
                            <mask
                              id="mask0_7937_5206"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="15"
                              height="16"
                            >
                              <rect
                                y="0.5"
                                width="15"
                                height="15"
                                fill="#D9D9D9"
                              />
                            </mask>
                            <g mask="url(#mask0_7937_5206)">
                              <path
                                d="M10.3919 8.46851H3.28125C3.14823 8.46851 3.03687 8.42361 2.94719 8.33382C2.8574 8.24414 2.8125 8.13278 2.8125 7.99976C2.8125 7.86674 2.8574 7.75539 2.94719 7.6657C3.03687 7.57591 3.14823 7.53101 3.28125 7.53101H10.3919L7.16109 4.30023C7.06818 4.20731 7.02229 4.09856 7.02344 3.97398C7.02469 3.8494 7.07375 3.73861 7.17063 3.64164C7.2676 3.55111 7.3774 3.50424 7.5 3.50101C7.6226 3.49778 7.7324 3.54466 7.82938 3.64164L11.792 7.60429C11.8506 7.66283 11.8918 7.72455 11.9158 7.78945C11.9398 7.85434 11.9519 7.92445 11.9519 7.99976C11.9519 8.07507 11.9398 8.14518 11.9158 8.21007C11.8918 8.27497 11.8506 8.33669 11.792 8.39523L7.82938 12.3579C7.74281 12.4444 7.63563 12.4887 7.50781 12.4907C7.38 12.4927 7.2676 12.4484 7.17063 12.3579C7.07375 12.2609 7.02531 12.1496 7.02531 12.0238C7.02531 11.898 7.07375 11.7866 7.17063 11.6896L10.3919 8.46851Z"
                                fill="white"
                              />
                            </g>
                          </svg>
                        </p>
                      </button>
                    </div>
                  </div>
                )}
                {logInSuccess && (
                  <div className={styles.reset_success}>
                    <div>
                      {" "}
                      <svg
                        width="70"
                        height="71"
                        viewBox="0 0 70 71"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_7967_8624"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="70"
                          height="71"
                        >
                          <rect y="0.5" width="70" height="70" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_7967_8624)">
                          <path
                            d="M30.9163 48.9166L51.4788 28.3541L47.3955 24.2708L30.9163 40.7499L22.6038 32.4374L18.5205 36.5208L30.9163 48.9166ZM34.9997 64.6666C30.965 64.6666 27.1733 63.901 23.6247 62.3697C20.0761 60.8385 16.9893 58.7603 14.3643 56.1353C11.7393 53.5103 9.66113 50.4235 8.12988 46.8749C6.59863 43.3263 5.83301 39.5346 5.83301 35.4999C5.83301 31.4652 6.59863 27.6735 8.12988 24.1249C9.66113 20.5763 11.7393 17.4895 14.3643 14.8645C16.9893 12.2395 20.0761 10.1614 23.6247 8.63013C27.1733 7.09888 30.965 6.33325 34.9997 6.33325C39.0344 6.33325 42.8261 7.09888 46.3747 8.63013C49.9233 10.1614 53.0101 12.2395 55.6351 14.8645C58.2601 17.4895 60.3382 20.5763 61.8695 24.1249C63.4007 27.6735 64.1663 31.4652 64.1663 35.4999C64.1663 39.5346 63.4007 43.3263 61.8695 46.8749C60.3382 50.4235 58.2601 53.5103 55.6351 56.1353C53.0101 58.7603 49.9233 60.8385 46.3747 62.3697C42.8261 63.901 39.0344 64.6666 34.9997 64.6666Z"
                            fill="#009A50"
                          />
                        </g>
                      </svg>
                    </div>

                    <h2>Congratulations!</h2>
                    <p>Your Account has been created successfully.</p>
                    <div
                      className={
                        styles.wrapper_divider_right_form_content_button
                      }
                    >
                      <button onClick={() => navigate("/customer-dashboard")}>
                        <p>
                          Go to Dasboard
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="16"
                            viewBox="0 0 15 16"
                            fill="none"
                          >
                            <mask
                              id="mask0_7937_5206"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="15"
                              height="16"
                            >
                              <rect
                                y="0.5"
                                width="15"
                                height="15"
                                fill="#D9D9D9"
                              />
                            </mask>
                            <g mask="url(#mask0_7937_5206)">
                              <path
                                d="M10.3919 8.46851H3.28125C3.14823 8.46851 3.03687 8.42361 2.94719 8.33382C2.8574 8.24414 2.8125 8.13278 2.8125 7.99976C2.8125 7.86674 2.8574 7.75539 2.94719 7.6657C3.03687 7.57591 3.14823 7.53101 3.28125 7.53101H10.3919L7.16109 4.30023C7.06818 4.20731 7.02229 4.09856 7.02344 3.97398C7.02469 3.8494 7.07375 3.73861 7.17063 3.64164C7.2676 3.55111 7.3774 3.50424 7.5 3.50101C7.6226 3.49778 7.7324 3.54466 7.82938 3.64164L11.792 7.60429C11.8506 7.66283 11.8918 7.72455 11.9158 7.78945C11.9398 7.85434 11.9519 7.92445 11.9519 7.99976C11.9519 8.07507 11.9398 8.14518 11.9158 8.21007C11.8918 8.27497 11.8506 8.33669 11.792 8.39523L7.82938 12.3579C7.74281 12.4444 7.63563 12.4887 7.50781 12.4907C7.38 12.4927 7.2676 12.4484 7.17063 12.3579C7.07375 12.2609 7.02531 12.1496 7.02531 12.0238C7.02531 11.898 7.07375 11.7866 7.17063 11.6896L10.3919 8.46851Z"
                                fill="white"
                              />
                            </g>
                          </svg>
                        </p>
                      </button>
                    </div>
                    <div
                      onClick={() => {
                        setIsOpen(false);
                        window.location.reload();
                      }}
                      style={{ color: "red", cursor: "pointer" }}
                    >
                      Back to homepage
                    </div>
                  </div>
                )}
              </div>{" "}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CustomerLogin;
